import { OverlayComponentUserParams } from "ag-grid-community";

export const overlayComponentParams: OverlayComponentUserParams = {
  loading: { overlayText: "Loading groups..." },
  noRows: { overlayText: "No groups found" },
  noMatchingRows: {
    overlayText: "No groups found",
  },
};
